import React from 'react';
import * as ReactDOM from 'react-dom/client';
import {
    BrowserRouter, Route, Routes, Navigate
} from 'react-router-dom';
// import reportWebVitals from './reportWebVitals';

import { ChakraProvider } from "@chakra-ui/react";
import NotFound from './pages/404.js';
import CalendarFeed from "./pages/CalendarFeed.js";
// import Climate from "./pages/Climate.js";
import CV from './pages/CV';
import FrontPage from "./pages/FrontPage.js";
import Laser from "./pages/Laser.js";
// import FrustumProjection from "./pages/FrustumProjection";
// import LSystem from "./pages/LSystem.js";
// import MultiColor3DPrint from "./pages/MultiColor3DPrint.js";
import Portfolio from "./pages/Portfolio.js";
import TaikoTest from "./pages/TaikoTest.js";
// import TextExtrusion from "./pages/TextExtrusion.js";

import "@fontsource/lobster/400.css";
import "@fontsource/playfair-display/400-italic.css";
import "@fontsource/courier-prime/700.css";
import "@fontsource/ubuntu/400.css";

import './index.css';
import theme from "./theme";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ChakraProvider theme={theme}>
            <BrowserRouter>
                <Routes>
                    <Route path="*" element={<NotFound />} />
                    <Route exact path="/" element={<FrontPage />} />
                    <Route exact path="/box" element={<Laser />} />
                    <Route exact path="/laser" element={<Navigate to="/box" replace />} />
                    {/* <Route exact path="/climate" element={<Climate />} /> */}
                    <Route exact path="/splatoon3" element={<CalendarFeed />} />
                    {/* <Route exact path="/l-system" element={<LSystem />} /> */}
                    <Route exact path="/resume" element={<CV />} />
                    <Route exact path="/portfolio" element={<Portfolio />} />
                    <Route exact path="/taiko" element={<TaikoTest />} />
                    {/* <Route exact path="/frustum" element={<FrustumProjection />} /> */}
                    {/* <Route exact path="/multicolor" element={<MultiColor3DPrint />} /> */}
                    {/* <Route exact path="/text-extrusion" element={<TextExtrusion />} /> */}
                </Routes>
            </BrowserRouter>
        </ChakraProvider>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
